import { createZodDto } from './zod';

import { z } from 'zod';

const UpdateOrganizationSchema = z.object({
  name: z.string(),
  currency: z.string(),
  areShortLinksPublic: z.boolean(),
  enforceRestrictedFolders: z.boolean().optional(),
  logo: z.string().nullable().optional(),
});

export class UpdateOrganizationDto extends createZodDto(
  UpdateOrganizationSchema,
) {}
